import { render, staticRenderFns } from "./demoTrading.vue?vue&type=template&id=67429b4b&"
import script from "./demoTrading.vue?vue&type=script&lang=js&"
export * from "./demoTrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports